/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MPIStrictHttpResponse } from '../../mpi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CoidClaimManagerDto } from '../../models/coid-claim-manager-dto';

export interface CoidClaimManagersElixirLiveGet$Params {
}

export function coidClaimManagersElixirLiveGet(http: HttpClient, rootUrl: string, params?: CoidClaimManagersElixirLiveGet$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<Array<CoidClaimManagerDto>>> {
  const rb = new RequestBuilder(rootUrl, coidClaimManagersElixirLiveGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MPIStrictHttpResponse<Array<CoidClaimManagerDto>>;
    })
  );
}

coidClaimManagersElixirLiveGet.PATH = '/CoidClaimManagers/ElixirLive';
